module.exports = __webpack_public_path__ + "img/airbase-hotspot-4.c80ebe9e.png";